import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { AnyTargetId } from '@portal-core/targets/constants/any-target-id.constant';
import { Target } from '@portal-core/targets/models/target.model';

@CollectionStateSelectors({
  stateType: TargetsState
})
@State<TargetsState>({
  name: TargetsState.source,
})
@Service({ autoProvided: false })
export class TargetsState extends CollectionStateBase {
  static override source: string = 'Targets';

  static override readonly defaultItems: Target[] = [{
    Id: AnyTargetId,
    ProjectId: 0,
    Path: 'Any Target'
  }];

  override getDefaultItems(): Target[] {
    return TargetsState.defaultItems;
  }

  getSource(): string {
    return TargetsState.source;
  }
}

@Service()
export class TargetsDataService extends CollectionDataServiceBase<Target> {
  protected readonly stateType = TargetsState;
}
